import { gql } from 'graphql.macro'

export default gql`
  fragment SensorEventTypeDebounceFragment on SensorEventTypeDebounce {
    sensorId
    eventTypeId
    periodInSeconds
  }
`
